import * as React from "react"

const Copyright = () => {
    return (
        <p className="p-2 text-center copyright font-italic">Pemalex Indústria e Comércio © 2022. Todos os direitos reservados. Feito com <span>&hearts;</span>  no Ceará</p>
    )
}

export default Copyright